import api from "../../../core/api";
import { ChangeShippingOptions, ShippingOption } from "../../shared/models/customerShippingOptions";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class CustomerShippinsOptionsApi {
  getShippingOptions(): Promise<ShippingOption> {
    return api.get<ShippingOption>(`/v1/shipping-options`, getRequestConfig()).then(x => x.data);
  }

  changeShippingOptions(model: ChangeShippingOptions) {
    return api.put<any>(`/v1/shipping-options`, model, getRequestConfig()).then(() => null);
  }
}

export default new CustomerShippinsOptionsApi();